var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (true)?_c('LoadingBar',{staticStyle:{"height":"100%"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }